<template>
  <div>
    
  </div>
</template>
<style lang="scss"  scoped>

</style>

<script>

// studycollect
export default {
  name: "null",
  data() {
    return {
    };
  },

  created() {
    console.log("created----");
   
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);
    // 判断是否从详情页面回来
    if (from.path == "/Study-detail") {
      to.meta.isBack = true;
    } else {
      to.meta.isBack = false;
    }
    next();
  },

  // 其他页面进来时更新初始数据
  activated() {
    
  },
  computed: {
  },
  mounted() {
  },

  methods: {
  },
};
</script>
